import { Container } from "reactstrap";
import { Dispatch } from "redux";
import React from "react";
import { SignoutCallbackComponent } from "redux-oidc";
import { UserManager } from "oidc-client";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import { authService } from "../Services/AuthService";

type DispatchProps = { redirect: () => void };

type Props = DispatchProps;
type State = { loaded: boolean };

class SingOutCallback extends React.Component<Props, State> {
  userManager?: UserManager;

  constructor(props: Props) {
    super(props);

    this.state = { loaded: false };
    authService.getUserManager().then(userManager => {
      this.userManager = userManager;
      this.setState({ loaded: true });
    });
  }

  render() {
    const { redirect } = this.props;
    const { loaded } = this.state;

    const visibleContent = (
      <Container className="p-2">
        <h3 className="text-center">Hold on while we finish logging you out</h3>
      </Container>
    );

    if (loaded) {
      const userManager = this.userManager as UserManager;
      return (
        <SignoutCallbackComponent
          successCallback={redirect}
          errorCallback={redirect}
          userManager={userManager}
        >
          {visibleContent}
        </SignoutCallbackComponent>
      );
    }
    return visibleContent;
  }
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  redirect: () => dispatch(replace("/"))
});

export default connect(
  null,
  mapDispatchToProps
)(SingOutCallback);
